import React from "react";

import { FormItem, Input } from "formik-antd";
import { Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import { WrapperForm, MediaContainer } from "./styled";
import { ComponentFormType } from "../content-forms.types";

const ComponentEight = ({
    index,
    setFieldValue,
    fieldsArrayEvent,
    values,
    uploadComplete,
    setUploadStatus,
    brandName,
}: ComponentFormType): JSX.Element => {
    return (
        <WrapperForm>
            <Row gutter={24}>
                <Col span={12}>
                    <MediaContainer
                        accept={"image/jpeg,image/jpg,image/png"}
                        value={values.components[index].fields.image1}
                        noteMessage={".jpeg, .jpg, .png (max 50 MB)"}
                        onChange={(e) => {
                            setUploadStatus(e?.status);
                            setFieldValue(`components[${index}].fields.image1`, e);
                        }}
                    >
                        <h1>Upload Banner +</h1>
                    </MediaContainer>
                    {brandName === "ALP" && (
                        <FormItem
                            label="Image alt text"
                            name={`components[${index}].fields.image1.altText`}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Input name={`components[${index}].fields.image1.altText`} />
                        </FormItem>
                    )}

                    <FormItem
                        name={`components[${index}].fields.caption1`}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                    >
                        <Input.TextArea
                            name={`components[${index}].fields.caption1`}
                            placeholder={"caption"}
                            rows={4}
                        />
                    </FormItem>
                </Col>
                <Col span={12}>
                    <MediaContainer
                        accept={"image/jpeg,image/jpg,image/png"}
                        value={values.components[index].fields.image2}
                        noteMessage={".jpeg, .jpg, .png (max 50 MB)"}
                        onChange={(e) => {
                            setUploadStatus(e?.status);
                            setFieldValue(`components[${index}].fields.image2`, e);
                        }}
                    >
                        <h1>Upload Banner +</h1>
                    </MediaContainer>
                    {brandName === "ALP" && (
                        <FormItem
                            label="Image alt text"
                            name={`components[${index}].fields.image2.altText`}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Input name={`components[${index}].fields.image2.altText`} />
                        </FormItem>
                    )}

                    <FormItem
                        name={`components[${index}].fields.caption2`}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                    >
                        <Input.TextArea
                            name={`components[${index}].fields.caption2`}
                            placeholder={"caption"}
                            rows={4}
                        />
                    </FormItem>
                </Col>
                <Col span={12}>
                    <MediaContainer
                        accept={"image/jpeg,image/jpg,image/png"}
                        value={values.components[index].fields.image3}
                        noteMessage={".jpeg, .jpg, .png (max 50 MB)"}
                        onChange={(e) => {
                            setUploadStatus(e?.status);
                            setFieldValue(`components[${index}].fields.image3`, e);
                        }}
                    >
                        <h1>Upload Banner +</h1>
                    </MediaContainer>
                    {brandName === "ALP" && (
                        <FormItem
                            label="Image alt text"
                            name={`components[${index}].fields.image3.altText`}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Input name={`components[${index}].fields.image3.altText`} />
                        </FormItem>
                    )}

                    <FormItem
                        name={`components[${index}].fields.caption3`}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                    >
                        <Input.TextArea
                            name={`components[${index}].fields.caption3`}
                            placeholder={"caption"}
                            rows={4}
                        />
                    </FormItem>
                </Col>
                <Col span={12}>
                    <MediaContainer
                        accept={"image/jpeg,image/jpg,image/png"}
                        value={values.components[index].fields.image4}
                        noteMessage={".jpeg, .jpg, .png (max 50 MB)"}
                        onChange={(e) => {
                            setUploadStatus(e?.status);
                            setFieldValue(`components[${index}].fields.image4`, e);
                        }}
                    >
                        <h1>Upload Banner +</h1>
                    </MediaContainer>
                    {brandName === "ALP" && (
                        <FormItem
                            label="Image alt text"
                            name={`components[${index}].fields.image4.altText`}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Input name={`components[${index}].fields.image4.altText`} />
                        </FormItem>
                    )}

                    <FormItem
                        name={`components[${index}].fields.caption4`}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                    >
                        <Input.TextArea
                            name={`components[${index}].fields.caption4`}
                            placeholder={"caption"}
                            rows={4}
                        />
                    </FormItem>
                </Col>
            </Row>

            <CloseOutlined
                className="remove-btn"
                onClick={() => {
                    uploadComplete !== "uploading" && fieldsArrayEvent.remove(index);
                }}
            />
        </WrapperForm>
    );
};

export default ComponentEight;
